import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'cmv-toolbar',
	templateUrl: './toolbar.component.html',
	styleUrls: ['./toolbar.component.scss'],
})
export class ToolbarComponent {
	@Input() title: string = '';
	@Input() image: string = './assets/images/general/logo.png';
	@Input() isTitle: boolean = false;
	@Input() isBack: boolean = true;
	@Input() urlBack: string = '..';

	@Output() clickBack: EventEmitter<void> = new EventEmitter();

	constructor() {}

	onClickBack(): void {
		this.clickBack.emit();
	}
}
